/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MaintenanceScheduleStateEnum } from './maintenanceScheduleStateEnum';


export interface MaintenanceScheduleDataSpec { 
    state: MaintenanceScheduleStateEnum;
    /**
     * Maintenance schedule start time
     */
    start_datetime?: Date;
    /**
     * Maintenance schedule end time
     */
    end_datetime?: Date;
    /**
     * List of Org Ids to be notified
     */
    org_ids?: Array<string>;
    /**
     * If null or true, will notify recipients by email.
     */
    notify?: boolean;
}
export namespace MaintenanceScheduleDataSpec {
}


